import React, { useContext, useEffect, useState } from "react";
import CardList from '../components/CardList'
import Screen from '../components/Screen';
import SectionBlocksRenderer from "../components/Sections/SectionBlocksRenderer";
import { i18nValue } from '../functions';
import { useItems } from "../hooks/useItems";
import { useHourDisabled } from "../hooks/useHourDisabled";
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { useParams } from 'react-router';
import { useNavigate } from "react-router";
import { T } from "react-translator-component";

const Listing = () => {
  const { entity } = useParams();
  const { sectionsByCode, placeholders, getUrlPath } = useContext(HotelContext)
  const { language } = useContext(UserContext)
  const { loading, items, error } = useItems(entity);
  const { validateHourDisabled } = useHourDisabled(entity);

  const [showCoverHourDisabled, setShowCoverHourDisabled] = useState('');

  // const { pathname } = useLocation();
  const navigate = useNavigate();

  const [showList, setShowList] = useState(false);

  useEffect(() => {
    setShowCoverHourDisabled(validateHourDisabled);
  }, [validateHourDisabled]);

  useEffect(() => {

    if (!items) { return }

    // Si existe solo un único dato en la lista, ir al detalle
    if (items?.length == 1) {
      const item = items[0];
      let auxPath = item.id;
      if (entity) {
        auxPath = `../${entity}/${item.id}`;
      }
      navigate(auxPath, {
        // state: { from: pathname },
      });
    } else {
      setShowList(true);
    }

  }, [items]);

  return (
    <Screen
      section={entity}
      title={i18nValue(sectionsByCode[entity], 'title', language)}
      description={i18nValue(sectionsByCode[entity], 'desc', language, placeholders)}
    >
      {
        showCoverHourDisabled
          ?
          <div className="cover-hour-disabled">
            <p>{T(showCoverHourDisabled)}</p>
          </div>
          :
          <>
            {(loading || !showList) && <div className="loading text-center mt-5"><div className="spinner-border"></div></div>}
            {error && <p>Error... {error}</p>}
            {(showList && items) &&
              <CardList
                data={items}
                language={language}
                entity={entity}
              />}
            <SectionBlocksRenderer
              section={sectionsByCode[entity]}
              language={language}
              sectionsByCode={sectionsByCode}
              getUrlPath={getUrlPath}
            />
          </>
      }
    </Screen>
  );
}

export {
  Listing
}